<template>
  <div class="app-container">
    <el-form ref="dataForm" :rules="rules" :model="temp" label-width="100px">
      <el-row>
        <el-col :span="18">
          <el-form-item label="门店名称" prop="name">
            <el-input v-model="temp.name" maxlength="30" show-word-limit />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="默认展示图" prop="default_img">
            <FileList v-model="temp.default_img" :item-width="88" :item-height="88" :limit="1" type="image" />
            <p class="tishi">建议尺寸：高80/宽140</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="门店图片" prop="img">
            <FileList v-model="temp.img" type="image" :item-width="88" :item-height="88" :limit="5" />
            <p class="tishi">最多上传5张展示图,建议尺寸：高200/宽375</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="门店类型" prop="type">
            <el-select v-model="temp.type" placeholder="请选择门店类型" multiple style="width: 100%;">
              <el-option v-for="item in dictionary['mdlx']" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="省市区" prop="province">
            <el-cascader v-model="provinceValue" placeholder="请选择省市区" :options="province" :props="{ expandTrigger: 'hover' }" style="width: 100%;" @change="handleChange"></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-row>
            <el-col :span="4">
              <el-form-item label="位置标注">
                <el-button type="primary" icon="el-icon-place" @click="openMap()">标记</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="经度" prop="longitude">
                <el-input v-model="temp.longitude" placeholder="经度"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="纬度" prop="latitude">
                <el-input v-model="temp.latitude" placeholder="纬度"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="门店地址" prop="address">
            <el-input v-model="temp.address" placeholder="请输入门店地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">

          <el-form-item label="详细地址" prop="detail_address">
            <el-input v-model="temp.detail_address" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="退款限制" prop="refund_time">
            <el-input-number v-model="temp.refund_time" :min="1" :max="24" />
            <p class="tishi">退款限制时间，单位：小时</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否推荐" prop="is_hot">
            <el-switch v-model="temp.is_hot" active-color="#13ce66" active-text="推荐" inactive-text="不推荐"></el-switch>
            <p class="tishi">推荐可在小程序首页进行展示（结合排序编号越小越靠前）</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="是否营业" prop="open_status">
            <el-switch v-model="temp.open_status" active-color="#13ce66" active-text="开启" inactive-text="关闭"></el-switch>
          </el-form-item>
          <el-form-item label="营业时间" prop="start_work_time">
            <el-row>
              <el-col :span="11">
                <el-time-select
                  v-model="
                    temp.start_work_time
                  "
                  style="width: 100%"
                  :picker-options="{
                    start: '00:00',
                    step: '01:00',
                    end: '24:00',
                  }"
                  placeholder="选择开始时间"
                ></el-time-select>
              </el-col>
              <el-col :span="2" style="text-align: center">-</el-col>
              <el-col :span="11">
                <el-time-select
                  v-model="
                    temp.end_work_time
                  "
                  style="width: 100%"
                  :picker-options="{
                    start: '00:00',
                    step: '01:00',
                    end: '24:00',
                  }"
                  placeholder="选择结束时间"
                ></el-time-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="18">
          <!-- <el-form-item label="基础设施" prop="infrastructure">
            <el-tag v-for="tag in infrastructure" :key="tag" closable :disable-transitions="false" @close="handleCloseinfrastructure(tag)">
              {{ tag }}
            </el-tag>
            <el-input v-if="inputinfrastructureVisible" ref="saveTagInputinfrastructure" maxlength="4" v-model="infrastructureValue" class="input-new-tag" size="small" @keyup.enter.native="handleInputinfrastructureConfirm" @blur="handleInputinfrastructureConfirm">
            </el-input>
            <el-tooltip v-else class="item" effect="dark" content="4字以内，如“智能控灯”" placement="right">
              <el-button class="button-new-tag" size="small" @click="showInputinfrastructure">+ 新增标签</el-button>
            </el-tooltip>
          </el-form-item> -->

          <el-form-item label="基础设施" prop="infrastructure">
            <section v-for="(val, index) in infrastructure" :key="index">
              <section>
                <el-row>
                  <el-col :span="12" style="display: flex;">
                    <el-form-item label="">
                      <FileList v-model="infrastructure[index].image" type="image" :item-width="36" :item-height="36" :limit="1" />
                    </el-form-item>
                    <el-form-item label="">
                      <el-input v-model="infrastructure[index].name" placeholder="请输入类型" :maxlength="4" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-button v-if="index === 0" type="primary" icon="el-icon-plus" plain style="margin-left:10px;" circle @click="addlastitems(index, 'infrastructure')" />
                    <el-button v-else type="danger" icon="el-icon-delete" plain style="margin-left:10px;" circle @click="rmlastitems(index, 'infrastructure')" />
                  </el-col>
                </el-row>
              </section>
            </section>
          </el-form-item>

        </el-col>
      </el-row>

      <el-row>
        <el-col :span="18">
          <!-- <el-form-item label="运动服务" prop="sportservice">
            <el-tag v-for="tag in sportservice" :key="tag" closable :disable-transitions="false" @close="handleClosesportservice(tag)">
              {{ tag }}
            </el-tag>
            <el-input v-if="inputsportserviceVisible" ref="saveTagInputsportservice" v-model="sportserviceValue" maxlength="4" class="input-new-tag" size="small" @keyup.enter.native="handleInputsportserviceConfirm" @blur="handleInputsportserviceConfirm">
            </el-input>
            <el-tooltip v-else class="item" effect="dark" content="4字以内，如“空调开放”" placement="right">
              <el-button class="button-new-tag" size="small" @click="showInputsportservice">+ 新增标签</el-button>
            </el-tooltip>
          </el-form-item> -->

          <el-form-item label="运动服务" prop="sportservice">
            <section v-for="(val, index) in sportservice" :key="index">
              <section>
                <el-row>
                  <el-col :span="12" style="display: flex;">
                    <el-form-item label="">
                      <FileList v-model="sportservice[index].image" type="image" :item-width="36" :item-height="36" :limit="1" />
                    </el-form-item>
                    <el-form-item label="">
                      <el-input v-model="sportservice[index].name" placeholder="请输入类型" :maxlength="4" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-button v-if="index === 0" type="primary" icon="el-icon-plus" plain style="margin-left:10px;" circle @click="addlastitems(index, 'sportservice')" />
                    <el-button v-else type="danger" icon="el-icon-delete" plain style="margin-left:10px;" circle @click="rmlastitems(index, 'sportservice')" />
                  </el-col>
                </el-row>
              </section>
            </section>
          </el-form-item>

        </el-col>
        <el-col :span="12">
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="18">
          <el-form-item label="经理姓名" prop="manager_name">
            <el-input v-model="temp.manager_name" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="经理电话" prop="manager_phone">
            <el-input v-model="temp.manager_phone" />
          </el-form-item>

        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="经理二维码" prop="manager_qrcode">
            <FileList v-model="temp.manager_qrcode" :item-width="88" :item-height="88" :limit="1" type="image" />
            <p class="tishi">建议尺寸：高130/宽130</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="排序" prop="order_no">
            <span slot="label">
              排序
              <el-tooltip content="排序越小，小程序展示越靠前" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
            <el-input-number v-model="temp.order_no" :min="1" :max="99999" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="门店介绍" prop="content">
            <WangEditor v-model="temp.content" :value.sync="temp.content" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="订场须知" prop="notice">
            <WangEditor v-model="temp.notice" :value.sync="temp.notice" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="padding: 15px; text-align: center;">
      <el-button type="primary" icon="el-icon-upload" @click="save()">保存</el-button>
      <router-link to="/site/index" class="el-button">返回</router-link>
    </div>
    <MapSelect ref="ms" @location="selectAddress" />
  </div>
</template>
<script>
import api from '@/api/site/site' // 和数据交互相关写在api 方便复用
import areaapi from '@/api/area' // 和数据交互相关写在api 方便复用
import WangEditor from '@/components/WangEditor'
import FileList from '@/components/attachment/FileList'
import dict_data from '@/api/system/dict_data'
import MapSelect from '@/components/map/map.vue'
export default {
  name: 'Edit',
  components: { WangEditor, FileList, MapSelect },
  data() {
    var validateinfrastructure = (rule, value, callback) => {
      if (this.infrastructure.length == 0) {
        callback(new Error('请添加基础设施'))
      } else {
        this.infrastructure.map(item => {
          if (!item.image) {
            callback(new Error('基础设施图标不能为空'))
            return
          }
          if (!item.name) {
            callback(new Error('基础设施名称不能为空'))
            return
          }
        })
        callback()
      }
    }
    var validatesportservice = (rule, value, callback) => {
      if (this.sportservice.length == 0) {
        callback(new Error('请添加运动服务'))
      } else {
        this.sportservice.map(item => {
          if (!item.image) {
            callback(new Error('运动服务图标不能为空'))
            return
          }
          if (!item.name) {
            callback(new Error('运动服务名称不能为空'))
            return
          }
        })
        callback()
      }
    }
    return {
      api,
      // 校验
      rules: {
        name: [{ required: true, message: '请输入门店名称', trigger: ['blur', 'change'] }],
        default_img: [
          { required: true, message: '请上传默认展示图', trigger: ['blur', 'change'] }
        ],
        type: [
          { required: true, message: '请选择门店类型', trigger: ['blur', 'change'] }
        ],
        img: [{ required: true, message: '请上传门店图片', trigger: ['blur', 'change'] }],
        longitude: [
          { required: true, message: '请选择标记', trigger: ['blur', 'change'] }
        ],
        latitude: [
          { required: true, message: '请选择标记', trigger: ['blur', 'change'] }
        ],
        province: [
          { required: true, message: '请选择省市区', trigger: ['blur', 'change'] }
        ],
        address: [
          { required: true, message: '请输入门店地址', trigger: ['blur', 'change'] }
        ],
        detail_address: [
          { required: true, message: '请输入详细地址', trigger: ['blur', 'change'] }
        ],
        manager_name: [
          { required: true, message: '请输入经理姓名', trigger: ['blur', 'change'] }
        ],
        refund_time: [
          { required: true, message: '请输入退款限制时间', trigger: ['blur', 'change'] }
        ],
        start_work_time: [
          { required: true, message: '请输入营业时间', trigger: ['blur', 'change'] }
        ],
        infrastructure: [
          { required: true, validator: validateinfrastructure, trigger: ['blur', 'change'] }
        ],
        sportservice: [
          { required: true, validator: validatesportservice, trigger: ['blur', 'change'] }
        ],
        manager_phone: [
          { required: true, message: '请输入经理电话', trigger: ['blur', 'change'] }
        ],
        manager_qrcode: [
          { required: true, message: '请上传经理二维码', trigger: ['blur', 'change'] }
        ],
        content: [
          { required: true, message: '请输入门店介绍', trigger: ['blur', 'change'] }
        ],
        notice: [
          { required: true, message: '请输入订场须知', trigger: ['blur', 'change'] }
        ]
      },
      open_status: 0, // 0 休息中 1 营业
      // infrastructuretag: [], //基础设施标签数组
      infrastructure: [{}], // 基础设施标签数组
      inputinfrastructureVisible: false, // 基础设施标签显示
      infrastructureValue: '', // 基础设施标签命名

      // sportservicetag: [], //运动服务标签数组
      sportservice: [{}], // 运动服务标签数组
      inputsportserviceVisible: false, // 运动服务标签显示
      sportserviceValue: '', // 运动服务标签命名
      temp: {
        id: undefined,
        order_no: 99999, // 排序
        name: '', // 名称
        default_img: '', // 默认图片
        img: '', // 图片
        type: '', // 类型
        address: '', // 地址
        detail_address: '', // 详细地址
        work_time: '', // 营业时间
        infrastructure: '', // 基础设施
        sportservice: '', // 运动服务
        manager_name: '', // 管理员姓名
        manager_phone: '', // 管理员电话
        manager_qrcode: '', // 管理员二维码
        longitude: '', // 经度
        latitude: '', // 纬度
        notice: '',
        refund_time: '',
        province: '', // 省
        city: '', // 市
        distinguish: ''// 区
      },
      // 字典参数
      dictionary: [],
      // 字典参数
      // 省市区
      province: [],
      provinceValue: []
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getMerchant()
    }
    this.resetFields()
    dict_data
      .Drop({
        sort: 'sort',
        order: 'asc',
        isPaginator: false,
        dict_code: 'mdlx,'
      })
      .then((response) => {
        this.dictionary = response.data
      })
    this.getArea()
  },
  mounted() {},
  methods: {

    addlastitems(index, field) {
      if (field === 'infrastructure') {
        this.infrastructure.push({})
      } else if (field === 'sportservice') {
        this.sportservice.push({})
      }
    },
    rmlastitems(index, field) {
      switch (field) {
        case 'infrastructure':
          this.infrastructure.splice(index, 1)
          break
        case 'sportservice':
          this.sportservice.splice(index, 1)
          break
      }
      this.$message.success('移除成功')
    },
    getArea() {
      areaapi.areaTreeList({}).then(res => {
        if (res.code === 200) {
          this.province = res.data
        }
      })
    },
    // 省市区联动菜单
    handleChange(value) {
      if (value) {
        this.temp.province = value[0]
        this.temp.city = value[1]
        this.temp.distinguish = value[2]
      }
    },
    resetFields() {
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    // 获取信息
    getMerchant() {
      api.Detail(this.$route.query.id).then((res) => {
        if (res.code === 200) {
          if (Number(res.data.open_status) === 1) {
            res.data.open_status = true
          } else {
            res.data.open_status = false
          }
          if (Number(res.data.is_hot) === 1) {
            res.data.is_hot = true
          } else {
            res.data.is_hot = false
          }
          // 基础设施标签
          if (res.data.infrastructure) {
            this.infrastructure = res.data.infrastructure
          } else {
            this.infrastructure = [{}]
          }
          // 运动服务标签
          if (res.data.sport_service) {
            this.sportservice = res.data.sport_service
          } else {
            this.sportservice = [{}]
          }
          this.provinceValue = res.data.province_text
          this.temp = res.data
          console.log(this.temp, '1223')
          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate()
          })
        }
      })
    },
    // 打开地图弹窗
    openMap() {
      if (this.temp.longitude && this.temp.latitude) {
        this.$refs.ms.show(
          this.temp.longitude,
          this.temp.latitude,
          this.temp.address
        )
      } else {
        this.$refs.ms.show()
      }
    },
    // 地址选择后的回调函数
    selectAddress(lnglat, address) {
      if (address) {
        // console.log(address, lat, lng, '1234')
        this.temp.address = address
      }
      this.temp.longitude = lnglat[0]
      this.temp.latitude = lnglat[1]
    },

    // 提交
    save() {
      const obj = { ...this.temp }
      if (obj.start_work_time && obj.end_work_time) {
        obj.work_time = obj.start_work_time + '-' + obj.end_work_time
      }
      obj.open_status = obj.open_status ? 1 : 0
      obj.is_hot = obj.is_hot ? 1 : 0
      obj.infrastructure = this.infrastructure
      obj.sport_service = this.sportservice
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          api.Create(obj).then((response) => {
            this.$notify({
              title: '成功',
              message: response.msg,
              type: 'success',
              duration: 2000
            })
            setTimeout(() => {
              this.$router.push('/site/index')
            }, 1500)
          })
        }
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999, // 排序
        name: '', // 名称
        default_img: '', // 默认图片
        img: '', // 图片
        type: '', // 类型
        address: '', // 地址
        detail_address: '', // 详细地址
        start_work_time: '', // 营业时间
        infrastructure: '', // 基础设施
        sportservice: '', // 运动服务
        manager_name: '', // 管理员姓名
        manager_phone: '', // 管理员电话
        longitude: '', // 经度
        latitude: '', // 纬度
        notice: '',
        refund_time: ''
      }
    },
    // 基础设施标签开始
    handleCloseinfrastructure(tag) {
      this.infrastructure.splice(this.infrastructure.indexOf(tag), 1)
    },
    showInputinfrastructure() {
      this.inputinfrastructureVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInputinfrastructure.$refs.input.focus()
      })
    },
    handleInputinfrastructureConfirm() {
      if (this.infrastructure.length >= 10) {
        this.$message({ message: '基础设施标签不能超过10个', type: 'warning' })
        this.inputinfrastructureVisible = false
        return
      }
      if (this.infrastructure.includes(this.infrastructureValue)) {
        this.$message({ message: '基础设施标签已存在', type: 'warning' })
        this.infrastructureValue = ''
        this.inputinfrastructureVisible = false
        return
      }
      const infrastructureValue = this.infrastructureValue
      if (infrastructureValue) {
        this.infrastructure.push(infrastructureValue)
      }
      this.inputinfrastructureVisible = false
      this.infrastructureValue = ''
    },
    // 基础设施标签结束
    // 运动服务标签开始
    handleClosesportservice(tag) {
      this.sportservice.splice(this.sportservice.indexOf(tag), 1)
    },
    showInputsportservice() {
      this.inputsportserviceVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInputsportservice.$refs.input.focus()
      })
    },
    handleInputsportserviceConfirm() {
      if (this.sportservice.length >= 10) {
        this.$message.error('运动服务标签不能超过10个')
        this.inputsportserviceVisible = false
        return
      }
      if (this.sportservice.includes(this.sportserviceValue)) {
        this.$message({ message: '运动服务标签已存在', type: 'warning' })
        this.sportserviceValue = ''
        this.inputsportserviceVisible = false
        return
      }
      const sportserviceValue = this.sportserviceValue
      if (sportserviceValue) {
        this.sportservice.push(sportserviceValue)
      }
      this.inputsportserviceVisible = false
      this.sportserviceValue = ''
    }
    // 运动服务标签结束
  }
}
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.tishi{
 color:  #606266;
}
</style>
